// removed by extract-text-webpack-plugin
module.exports = {"welcomePage":"Welcome__welcomePage","growDotQello":"Welcome__growDotQello","growDotBlue":"Welcome__growDotBlue","growDotGolden":"Welcome__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Welcome/Welcome.scss
// module id = 1926
// module chunks = 0